import React from 'react'

const Learnmore = ({treatment}) => {
  return (
    <div>
      <div className='grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-5 my-10 mx-5'>
      {
        treatment.map((items) => (
          <div key={items.id} className='w-[350px] h-fit py-4'>
            <img src={items.img} alt="" className='  w-[300px] h-[250px]' />
            <h3 className='font-bold w-full  text-[18px] my-5'>{items.text}</h3>
            <h3 className=''>{items.text2} <span className='text-[#1473AC]  underline py-3'>{items.text3}</span></h3>
           
          </div>  
        ))
      }
    </div>
    </div>
  )
}

export default Learnmore
